import {Button, ButtonSize, ColourSolid, DropdownMenu, ItemMenuEntry, useLayout} from "@twigsby/frontend-framework";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDoorOpen} from "@fortawesome/pro-solid-svg-icons/faDoorOpen";
import {faRectangleHistory} from "@fortawesome/pro-solid-svg-icons/faRectangleHistory";
import React from "react";
import {useUKPBAuth} from "../../Providers/AuthProvider";
import {NavLink, useNavigate, useParams} from "react-router-dom";
import { useAccountUser } from "@twigsby/client-data";
import {Logo} from "../Logo";

const UserPageHeader = () => {
    const navigate = useNavigate();
    const { pageId } = useParams();
    const { data } = useAccountUser();
    const { isMedium, isLarge, isXL } = useLayout();

    const {
        LogOut,
    } = useUKPBAuth();

    return (
        <div className={`row ${!isMedium ? 'p-sm' : ''} ${isXL ? 'mt-sm mb-lg' : ''} raised-header`}>
            <div className={'col-xs-12 col-center-md-8 col-center-lg-10 col-center-xxl-8'}>

                <div className='row'>
                    {isLarge && (
                        <div className='col-xs-12 col-md-3 col-xl-3' />
                    )}
                    <div className='col-xs-12 col-lg-9 col-xl-6'>
                        <div className={`row ${isMedium ? 'mt-md' : ''}`}>
                            <div className='col-xs-6'>
                                <NavLink to={`/sends-page/${pageId}`}>
                                    <Logo />
                                </NavLink>
                            </div>
                            <div className='col-xs-6 text-right'>
                                <DropdownMenu
                                    trigger={
                                        <Button title={data?.name as string} colour={ColourSolid.Text} size={ButtonSize.Small} showArrow={true} />
                                    }
                                >
                                    <ItemMenuEntry title={'History'} onClick={() => navigate('../sends-page/history')} icon={faRectangleHistory} />
                                    {(!data?.roles.includes('SENDS_PAGE_ADMIN') && !data?.roles.includes('MANAGER')) && (
                                        <>
                                            <ItemMenuEntry title={'Divider'} sectionDivider={true} />
                                            <ItemMenuEntry title={'Logout'} onClick={() => LogOut()} icon={faDoorOpen} />
                                        </>
                                    )}
                                </DropdownMenu>
                            </div>
                        </div>
                    </div>
                    {isXL && (
                        <div className='col-md-3' />
                    )}
                </div>

            </div>
        </div>
    )
}

export default UserPageHeader
